import { useShellHeaderState } from '@/shared/shell/ShellHeaderContext';
import AppTopbar from '@/app/layout/AppTopbar';
import ShellMenuToggle from '@/app/layout/ShellMenuToggle';
import {
  SHELL_TOPBAR_BORDER,
  SHELL_TOPBAR_HEIGHT,
  SHELL_TOPBAR_SURFACE,
} from '@/app/layout/shellLayoutTokens';

function AppShellHeader({ isSidebarPinned, isMobileSidebarOpen, onToggleSidebar, onToggleMobile }) {
  const { title, subtitle } = useShellHeaderState();

  return (
    <header
      className={`sticky top-0 z-20 border-b ${SHELL_TOPBAR_BORDER} ${SHELL_TOPBAR_SURFACE} ${SHELL_TOPBAR_HEIGHT}`}
    >
      <div className="flex h-full items-center justify-between gap-3 px-3 md:px-4 lg:px-5">
        <div className="flex min-w-0 flex-1 items-center gap-2 sm:gap-3">
          <ShellMenuToggle
            isSidebarExpanded={isSidebarPinned}
            isMobileOpen={isMobileSidebarOpen}
            onToggleSidebar={onToggleSidebar}
            onToggleMobile={onToggleMobile}
            variant="ghost"
          />
          <div className="min-w-0">
            <h1 className="truncate text-base font-bold tracking-tight text-strong md:text-lg">
              {title}
            </h1>
            {subtitle ? (
              <p className="hidden truncate text-xs text-subtle sm:block">{subtitle}</p>
            ) : null}
          </div>
        </div>
        <AppTopbar />
      </div>
    </header>
  );
}

export default AppShellHeader;
